
import styled from '@emotion/styled/macro';
import rem from '../../utils/rem/rem';


export const HeaderWrapper = styled.div`
  display: flex;
`;

export const StyledTitle = styled.div`
  font-family: 'Open Sans';
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.gray600};
  padding:${rem(4)} ${rem(8)};
`;